// extracted by mini-css-extract-plugin
export default {"price_wrapper":"PriceSection_price_wrapper__v3R4L","flex":"PriceSection_flex__HQZzW","action_button":"PriceSection_action_button__5-6IC"};